import {
    Component,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ColourPaletteType, IDropdown, SizeType } from '@dxp/core/models';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { TelXLDropdownBaseComponent } from './dropdown.base.component';

@Component({
    selector: 'telxl-dropdown',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLDropdownBaseComponent],
    template: `
        <telxl-dropdown-base
            [menuItems]="menuItems"
            [selected]="selected"
            [multiSelect]="false"
            [colour]="colour"
            [position]="position"
            [outline]="outline"
            [disabled]="disabled"
            [size]="size"
            [class]="class"
            [text]="text"
            [placeholder]="placeholder"
            [maxHeight]="maxHeight"
            (selectedChange)="handleSelectedChange($event)"
        ></telxl-dropdown-base>
    `,
})
export class TelXLDropdownComponent<T> {
    @Input({ required: true }) menuItems: IDropdown<T>[] = [];
    @Input({ required: true }) colour!: ColourPaletteType;
    @Input() selected!: T;
    @Input() position: Placement = 'bottom-start';
    @Input() outline = false;
    @Input() disabled = false;
    @Input() size: SizeType | null = null;
    @Input() class = '';
    @Input() text = '';
    @Input() placeholder = '';
    @Input() maxHeight = '100vh';

    @Output() selectedChange = new EventEmitter<T>();

    handleSelectedChange(event: T | T[]) {
        this.selectedChange.emit(event as T);
    }
}
